(function() {

    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$window','$rootScope', '$stateParams', 'DataUtils', 'entity', 'Company', 'CompanyStatus', 'Sector', 'Organisation', 'Principal', 'ModerationOrganisation'];

    function CompanyDialogController ($timeout, $scope, $window, $rootScope, $stateParams, DataUtils, entity, Company, CompanyStatus, Sector, Organisation, Principal, ModerationOrganisation) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.companystatuses = CompanyStatus.query();
        vm.sectors = Sector.query();

        vm.companiesNoResults = false;
        vm.getCompanies = getCompanies;
        vm.isAdmin = isAdmin;
        vm.currentAccount = null;

        vm.deleteOrganisation = deleteOrganisation;
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        $timeout(function (){
            vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
            if (entity.id){
                $scope.$parent.vm.edit = true;
            }

            if (vm.company.selfHolding){
                vm.company.holding = vm.company;
            }

            $scope.$parent.vm.selectedContribution="new-company";
            angular.element('.form-group:eq(0)>input').focus();
        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function clear () {
            $scope.$parent.$dismiss();
        }

        function save () {
            vm.isSaving = true;
            // if (isAdmin() || vm.company.myContribution){
                if (vm.company.id !== null) {
                    // UPDATE
                    if (vm.company.holding == ""){
                        vm.company.holding = null;
                    }
                    if (vm.company.holding && (vm.company.holding.id==vm.company.id)){
                        vm.company.holding=null;
                        vm.company.selfHolding=true;
                    } else {
                        vm.company.selfHolding=false;
                    }

                    if (vm.company.moderationId){
                        // Il s'agit d'une modération. Update de la company à partir de la modération
                        ModerationOrganisation.updateAndApprove({id: vm.company.moderationId}, vm.company, onSaveSuccess, onSaveError);
                    } else {
                        // Update direct de la company en base
                        Organisation.update(vm.company, onSaveSuccess, onSaveError);
                    }
                } else {
                    // CREATION
                    if (vm.company.moderationId){
                        // Il s'agit d'une modération. Création de la company à partir de la modération
                        ModerationOrganisation.createAndApprove({id: vm.company.moderationId}, vm.company, onSaveSuccess, onSaveError);
                    } else {
                        // Création direct de la company en base
                        vm.company.type = 'company';
                        Organisation.save(vm.company, onSaveSuccess, onSaveError);
                    }
                }
            /*
            } else {
                // Création d'une modération si non admin
                var mCompany = Object.assign({}, vm.company);
                mCompany.positions = null;
                if (vm.company.id !== null) {
                    mCompany['referencedOrganisation']  = Object.assign({}, vm.company);
                    mCompany.id = null;
                    ModerationOrganisation.mupdate(mCompany, onModerationSaveSuccess, onSaveError);
                } else {
                    mCompany.type = 'company';
                    ModerationOrganisation.msave(mCompany, onModerationSaveSuccess, onSaveError);
                }
            }
            */
        }

        function onModerationSaveSuccess (result) {
            $scope.$emit('quilinkApp:moderationCompanyUpdate', result);
            $rootScope.$broadcast('quilinkApp:moderationCompanyUpdate', result);
            vm.company.hasModeration = true;
            vm.isSaving = false;
            $scope.$parent.$close();
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:companyUpdate', result);
            $rootScope.$broadcast('quilinkApp:companyUpdate', result);
            $scope.$parent.$close();
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogo = function ($file, company) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        company.logo = base64Data;
                        company.logoContentType = $file.type;
                    });
                });
            }
        };

        function getCompanies(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                vm.organizationsNoResults = companies.length === 0;
                if (isAdmin()) {
                    companies.map( function(org) {
                        if (org.equipeCommerciale) {
                            org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                        }
                    });
                }
                return companies;
            });
        }


        function deleteOrganisation() {
            vm.isSaving = true;
            if (vm.company.id !== null) {
                Organisation.delete({
                    id: vm.company.id
                }, onDeleteSuccess, onSaveError);
            }
        }

        function onDeleteSuccess(result) {
            $scope.$emit('quilinkApp:companyUpdate', null);
            $rootScope.$broadcast('quilinkApp:companyUpdate', null);
            vm.isSaving = false;
            $window.location.href = '/';
        }

    }
})();
